import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { galleryListQueries } from '@/services/galleryManagement/galleryManagement.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useHostGalleryMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('deleteHostGallery', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: galleryListQueries.all() });
      toast.success(res.message);
    },
    onError: (err) => {
      toast.error(err.message || 'Failed to delete the gallery image.');
    },
  });
  return { mutate: mutateAsync };
};
